<table mat-table [dataSource]="this.coleccionistas.data" class="w-full">

    <!-- avatar -->
    <ng-container matColumnDef="avatar">
        <th mat-header-cell *matHeaderCellDef>  </th>
        <td mat-cell *matCellDef="let element" class="w-1/12 text-center items">
            <div class="flex items-center justify-center">
                <user-avatar-name [name]="element.coleccionista.nombre"></user-avatar-name>
            </div>
        </td>
    </ng-container>

    <!-- Detalle Column -->
    <ng-container matColumnDef="detalleColeccionista">
      <th mat-header-cell *matHeaderCellDef> Coleccionista </th>
      <td mat-cell *matCellDef="let element" class="w-4/12 px-2"> 
            <div class="py-4" >

                <div class="text-sm">
                    <mat-icon class="text-md">tag</mat-icon>
                    <span>Id: </span>  <span class="font-bold">{{ element.coleccionista.coleccionistaUuid}}</span>
                </div>

                <div class="text-sm">
                    <mat-icon class="text-md">description</mat-icon>
                    <span>Nombre: </span>  <span class="font-bold">{{ element.coleccionista.nombre}}</span>
                </div>

                <div class="text-sm">
                    <mat-icon class="text-md">mail</mat-icon>
                    <span>Correo Electrónico: </span>  <span class="font-bold">{{ element.coleccionista.correoElectronico}}</span>
                </div>

                <div class="text-sm">
                    <mat-icon class="text-md">tag</mat-icon>
                    <span>Código Coleccionista: </span>  <span class="font-bold">{{element.coleccionista.codigoColeccionista}}</span>
                </div>
                <div class="text-sm">
                    <mat-icon class="text-md">person</mat-icon>
                    <span>Registrado por: </span>  <span class="font-bold">{{ element.coleccionista.creadoPor.nombreCompleto}}</span>
                </div>

                

            </div>

      </td>
    </ng-container>
  
    <!-- Seccion -->
    <ng-container matColumnDef="seccion">
      <th mat-header-cell *matHeaderCellDef class="px-2"> Sección </th>
      <td mat-cell *matCellDef="let element" class="w-2/12 px-2 "> 
        <status-sticker [estado]="element.coleccionista.seccion?.descripcion" [color1]="element.coleccionista.seccion?.valor1" [color2]="element.coleccionista.seccion?.valor2"></status-sticker>
      </td>
    </ng-container>

    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> </th>
      <td mat-cell *matCellDef="let element"  class="w-1/12 px-2"> 
            <button mat-icon-button (click)="openDetails(element.coleccionista)">
                <mat-icon>open_in_new</mat-icon>
            </button>
      </td>
    </ng-container>
  
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  
  <mat-paginator [length]="coleccionistas.total" [pageSize]="pageSizes" [hidePageSize]="true"></mat-paginator>